<template>
	<div>
		<div class="text-center mgs-scorecard-input" v-if="isReadOnly" v-html="scrambleValue"></div>
		<select class="mgs-scorecard-input" v-else v-model="type">
			<option value="bunker">Sand</option>
			<option value="pitch">Pitch</option>
			<option value="chip">Chip</option>
			<option value="full_shot">Full</option>
			<option value="off_green_putt">Putt</option>
		</select>
	</div>
</template>
<script>
/** @format */

export default {
	name: "CourseScrambleSelect",
	props: {
		courseHole: {
			type: Object,
			required: true
		},
		isReadOnly: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		scrambleValue() {
			switch (this.type) {
				case "bunker":
					return "Bunker";
					break;
				case "pitch":
					return "Pitch";
					break;
				case "chip":
					return "Chip";
					break;
				case "full_shot":
					return "Full shot";
					break;
				case "off_green_putt":
					return "Putt from off green";
					break;
			}
		},
		type: {
			get() {
				for (let type of this.types) {
					if (!!this.courseHole[type]) {
						return type;
						break;
					}
				}
				return "";
			},
			set(v) {
				this.resetTypes();
				if (!!!this.courseHole.gir) {
					this.courseHole[v] = true;
				}
			}
		}
	},
	methods: {
		resetTypes() {
			for (let type of this.types) {
				this.courseHole[type] = null;
			}
		}
	},
	watch: {
		"courseHole.gir"(hit) {
			if (!!hit) this.resetTypes();
		}
	},
	data() {
		return {
			types: ["bunker", "pitch", "chip", "full_shot", "off_green_putt"]
		};
	}
};
</script>
